import React from 'react'
import { Card, Row, Col } from 'react-bootstrap'
import Document from '../Document'
import EnrollButton from '../EnrollButton'
import EnrollEmailButton from '../EnrollEmailButton'
import NextStudentButton from '../NextStudentButton'
import { connect } from 'react-redux'

const Documents = ({ auth, documents, controlNumber, updateHandler, inscrito, nss, equivalencia, allowEnrollmentStateToggle = false }) => {
  return (
    <Card
      bg="secondary"
      text="white"
      border="secondary"
      className="mt-5 mb-5"
    >
      <Card.Header className="d-flex justify-content-sm-between align-items-md-center">
        <Col className="bg-transparent">
        <h5>Documentos</h5>
        </Col>
        <Col className="bg-transparent d-flex justify-content-end align-items-center">
        { 
          auth.user.role && !inscrito ? (
            allowEnrollmentStateToggle && <EnrollButton updateHandler={() => updateHandler()} controlNumber={controlNumber} />
          ) : auth.user.role ? (
            <EnrollEmailButton controlNumber={controlNumber} />
          ) : null
        }
        { 
          auth.user.role && (
            <NextStudentButton controlNumber={controlNumber}/>
          )
        }
        </Col>
      </Card.Header>
      <Card.Body className="body-card">
        <Row>
          {
            documents.map((document, key) => (
            <Col xs={{ span: 12 }} md={{ span: 4 }} className="mb-4" key={key}>
              <Document {...document} controlNumber={controlNumber} nss={nss} equivalencia={equivalencia}/>
            </Col>
            ))
          }
        </Row>
      </Card.Body>
    </Card>
  )
}

const mapStateToProps = (state) => ({
  auth : state.auth
})

export default connect(mapStateToProps, null)(Documents)